export const DEFAULT_DROPDOWN_CONFIG = {
    highlight: false,
    create: false,
    persist: true,
    plugins: ['dropdown_direction', 'remove_button'],
    dropdownDirection: 'down',
};

export const WITHDRAW_REASON = [
    {
        status: 1,
        reason: 'Yes - I have found another job'
    },
    {
        status: 2,
        reason: 'Yes - I\'m no longer interested(for other reasons)'
    },
    {
        status: 3,
        reason: 'No - I am still interested'
    }
];


export const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote'],

    [{ 'list': 'ordered'}, { 'list': 'bullet' }],

    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

];

export const QUILL_EDITOR_CONFIG = {
    modules: {
        toolbar: toolbarOptions
    }
};

export const ROLE = {
    jobSeeker: 'job_seeker',
    employer: 'employer',
    admin: 'administrator',
    superAdmin: 'superadministrator'
};

export const CONFIG_MODAL = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: false
};
